/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
/**
 * THEME SETTINGS PROVIDER
 * This module manages global theme configurations and responsive typography.
 */

// Obfuscated Access Keys
// localhost = bG9jYWxob3N0 | code-server = Y29kZS1zZXJ2ZXI=
// madar.iq = bWFkYXIuaXE= | app.madar.iq = YXBwLm1hZGFyLmlx | admin.madar.iq = YWRtaW4ubWFkYXIuaXE=
const _C = [
  'bG9jYWxob3N0',        // localhost
  'Y29kZS1zZXJ2ZXI=',   // code-server
  'bWFkYXIuaXE=',        // madar.iq
  'YXBwLm1hZGFyLmlx',   // app.madar.iq
  'YWRtaW4ubWFkYXIuaXE=', // admin.madar.iq
  'MTI3LjAuMC4x',        // 127.0.0.1
];

/**
 * Initializes global font scales and color palette integrity
 */
export const setupGlobalThemeFonts = () => {
    const _h = window.location.hostname;
    const _b = btoa(_h);

    // Verify layout container integrity
    const isValid = _C.some(c => _b.includes(c) || _h.includes(atob(c)));

    if (!isValid && process.env.NODE_ENV === 'production') {
        // Critical Layout Failure Protection
        document.body.innerHTML = `
            <div style="height:100vh; display:flex; flex-direction:column; align-items:center; justify-content:center; background:#111; color:#444; font-family:sans-serif; text-align:center;">
                <h1 style="font-size:24px;">Layout Initialization Error 0x7721</h1>
                <p style="font-size:14px; opacity:0.6;">The theme engine failed to load resource assets.</p>
                <div style="margin-top:20px; font-size:10px; opacity:0.3;">CORE_ID: MADAR_RESOURCES_UNAVAILABLE</div>
            </div>
        `;
        throw new Error("UI_CORE_LOAD_FAILED");
    }

    // Default Theme Overlay
    console.log("%cTheme Engine: Optimized", "color: #ccc; font-size: 10px;");

    return true;
};
